<div class="popup-container-wrapper" #popupContainer>
  <div class="close-popup">
    <u-icon class="close-icon" (mousedown)="onCancel()" [model]="{ type: 'font', value: 'icon-Windows-close' }"></u-icon>
  </div>
  <div class="popup-container">
    <div class="popup-header">
      <span class="title">Create Slack Assistant</span>
    </div>

    <div class="popup-main">
      <h5 class="create-post-subtitle">
        Set up this assistant for a specific Slack channel.<br />
        The Unleash bot must already be invited to that channel.
      </h5>
      <div class="popup-content">
        <div class="section">
          <p class="section-title">Select Workspace</p>
          @if (isLoadingInstallations()) {
            <div class="ghost-container">
              <div class="installations-ghost"></div>
            </div>
          } @else {
            <u-dropdown
              [options]="installationsList()"
              optionLabel="label"
              [selectedValue]="selectedWorkspace()"
              (onChange)="onInstallationSelected($event)"
              [styles]="{ width: '440px', 'font-size': '14px' }"
              [appendTo]="popupContainer"
              placeholder="Select a workspace"
              dropdownSize="large"
              class="options-elements"
              [panelStyleClass]="'slack-assistant-popup-dropdown'"
              [disabled]="installationsList().length === 1 ? true : false"
            ></u-dropdown>
          }
        </div>
        <div class="section">
          <div class="section-header">
            <p class="section-title">Slack Channel ID</p>
            <u-icon
              class="icon"
              [model]="{ type: 'font', value: 'icon-info' }"
              [styles]="{ color: 'var(--color-primary)', fontSize: '14px', cursor: 'pointer' }"
              uTooltip="How to find a Slack channel ID"
              uTooltipPosition="above"
              (click)="openInfoPopup()"
            ></u-icon>
          </div>
          <u-input
            #channelIdInput
            [placeholder]="'Paste channel ID here'"
            [sizeElement]="'medium'"
            [stateElement]="errorText() ? 'error' : 'regular'"
            [errorText]="errorText()"
            (onChange)="onChannelIDChange($event)"
          ></u-input>
        </div>
      </div>
    </div>
    <div class="wizard-footer">
      <span class="step">Step {{ step }} of {{ stepsLength }}</span>
      <div class="actions-container">
        <u-button
          [label]="'Cancel'"
          (onClick)="onCancel()"
          class="left-button"
          [typeElement]="'secondary'"
          [styleType]="'outlined'"
          [versionNumber]="2"
          [stateElement]="selectedWorkspace() || slackChannelID() ? 'regular' : 'disabled'"
        ></u-button>
        <u-button
          [label]="'Next'"
          (onClick)="onContinue()"
          class="right-button"
          [stateElement]="continueButtonState()"
          [typeElement]="'primary'"
          [versionNumber]="2"
        ></u-button>
      </div>
    </div>
  </div>
</div>
